import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_kids_all: FaireCategoryEntity = {
  token: "cat_kids-all",
  type: "category",
  name: "All kids & baby",
  level: 2,
  parentToken: "cat_kids-baby",
  href: "/category/kids-baby",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
